module.exports = __webpack_public_path__ + "img/home.62f6066e.png";